import * as React from "react";
import { Avatar } from "@mui/material";
import user from "../../assets/user.png";

export default function AvatarComponent(props) {
  return (
    <Avatar
      src={props.details.img ? props.details.img : user}
      sx={{
        width: props.details.width ? props.details.width : 56,
        height: props.details.height ? props.details.height : 56,
      }}
    />
  );
}
